import React from 'react';
import useCondition from '../../useCondition';
import moment from 'moment';

export default () => {
  const {condition} = useCondition();
  const dateFormat = 'YYYY/MM/DD';

  if (!condition?.inflowDateFrom && !condition?.inflowDateTo) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2 last-of-type:border-none">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">
          {condition?.inflowDateType === 'latest' ? '最新流入日' : '初回流入日'}
        </h4>
      </div>
      <div className="flex flex-wrap items-center gap-1">
        <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
          <>
            {condition?.inflowDateFrom &&
              moment(condition.inflowDateFrom).format(dateFormat)}
            ~
            {condition?.inflowDateTo &&
              moment(condition.inflowDateTo).format(dateFormat)}
          </>
        </span>
      </div>
    </div>
  );
};
